export default __webpack_public_path__ + "static/apps_developed_uk-2e70c06a65c27ad5c908a2eb4d78d40b.webp";